import { render, staticRenderFns } from "./bannerImgnew.vue?vue&type=template&id=fb62f1fe&scoped=true"
import script from "./bannerImgnew.vue?vue&type=script&lang=js"
export * from "./bannerImgnew.vue?vue&type=script&lang=js"
import style0 from "./bannerImgnew.vue?vue&type=style&index=0&id=fb62f1fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb62f1fe",
  null
  
)

export default component.exports